// extracted by mini-css-extract-plugin
export default {"xero":"xero_xero__VnCqj","xero__main":"xero_xero__main__A-uqa","xero__main__col":"xero_xero__main__col__RY5QD","xero__connect-button":"xero_xero__connect-button__1YTVc"};